export default __webpack_public_path__ + "static/round-a6c6710ac96e8f2d1f331f81617f5ca1.svg";